import { render, staticRenderFns } from "./MaternityWard.vue?vue&type=template&id=1970ae5a&"
import script from "./MaternityWard.vue?vue&type=script&lang=js&"
export * from "./MaternityWard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports